"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function e(e) {
  return e && "object" == _typeof(e) && "default" in e ? e.default : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var n = require("react"),
    i = e(n),
    t = require("xstate"),
    a = require("@xstate/react"),
    o = require("@apollo/react-hooks"),
    r = e(require("@jetshop/core/components/AuthContext/useAuth")),
    s = require("react-router"),
    d = e(require("qs")),
    u = e(require("jwt-decode")),
    l = require("react-cookie");

function c() {
  return (c = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var i = arguments[n];

      for (var t in i) {
        Object.prototype.hasOwnProperty.call(i, t) && (e[t] = i[t]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var m = {
  loginPath: "/login",
  signupPath: "/signup",
  loginOnActivation: !0,
  activateOnSoftLogin: !0,
  redirectOnLookupFailure: !1
},
    k = {
  NoActionRequired: "NO_ACTION_REQUIRED",
  CustomerNotFound: "NON_EXISTING_CUSTOMER",
  CustomerAlreadyActivated: "ALREADY_ACTIVATED",
  AdditionalUserDataRequired: "ADDITIONAL_USER_DATA_REQUIRED",
  UnableToActivateCustomer: "UNABLE_TO_ACTIVATE"
},
    v = t.send(function (e) {
  return {
    type: k[e.status]
  };
}),
    p = t.assign({
  status: function status(e, n) {
    var i,
        t = (null == n || null === (i = n.data) || void 0 === i ? void 0 : i.error)[0];
    return k[t.message] ? t.message : "NoActionRequired";
  },
  customer: function customer(e, n) {
    return n.data.activateExternalCustomerByToken ? c({}, n.data.activateExternalCustomerByToken.customer) : void 0;
  }
}),
    g = t.assign({
  customer: function customer(e, n) {
    var i, t;
    return null !== (i = n.data) && void 0 !== i && null !== (t = i.externalCustomerLookup) && void 0 !== t && t.customer ? c({}, e.customer, {}, n.data.externalCustomerLookup.customer, {
      streetName: n.data.externalCustomerLookup.customer.address,
      mobilePhone: n.data.externalCustomerLookup.customer.mobilePhoneNumber
    }) : c({}, e.customer);
  }
}),
    _ = function _(e) {
  return t.Machine({
    id: "SoftLoginMachine",
    initial: "idle",
    context: {
      externalCustomerToken: "",
      customer: void 0,
      status: "NoActionRequired",
      providerOptions: c({}, m, {}, e)
    },
    states: {
      idle: {
        always: [{
          target: "checking_action_required",
          cond: "shouldInitialize"
        }, {
          target: "no_action_required"
        }]
      },
      activated: {
        always: [{
          target: "checking_action_required",
          cond: function cond(e) {
            return e.providerOptions.loginOnActivation;
          }
        }, {
          target: "no_action_required"
        }]
      },
      checking_action_required: {
        invoke: {
          id: "tryLoginWithExternalToken",
          src: "tryLoginWithExternalToken",
          onDone: "no_action_required",
          onError: "action_required"
        }
      },
      no_action_required: {
        type: "final"
      },
      action_required: {
        id: "action_required",
        initial: "checking_should_activate",
        states: {
          checking_should_activate: {
            always: [{
              target: "try_activate",
              cond: function cond(e) {
                return e.providerOptions.activateOnSoftLogin;
              }
            }, {
              target: "#non_existing"
            }]
          },
          try_activate: {
            invoke: {
              id: "tryActivateByExternalToken",
              src: "tryActivateByExternalToken",
              onDone: {
                target: "#SoftLoginMachine.activated"
              },
              onError: {
                target: "activation_failed",
                actions: ["setStatusReason", "sendActionEvent"]
              }
            }
          },
          activation_failed: {
            id: "activation_failed",
            initial: "status_response",
            states: {
              status_response: {
                on: {
                  NON_EXISTING_CUSTOMER: "non_existing",
                  ALREADY_ACTIVATED: "already_activated",
                  ADDITIONAL_USER_DATA_REQUIRED: "additional_data",
                  NO_ACTION_REQUIRED: "non_existing",
                  UNABLE_TO_ACTIVATE: "unable_to_activate"
                }
              },
              non_existing: {
                id: "non_existing",
                type: "final"
              },
              already_activated: {
                id: "already_activated",
                type: "final"
              },
              additional_data: {
                id: "additional_data",
                type: "final"
              },
              unable_to_activate: {
                id: "unable_to_activate",
                type: "final"
              }
            }
          }
        }
      }
    }
  }, {
    actions: {
      setStatusReason: p,
      sendActionEvent: v,
      storeCustomer: g
    }
  });
},
    y = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "ActivateExternalToken"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "input"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "ActivateExternalCustomerByTokenInput"
          }
        }
      },
      directives: []
    }],
    directives: [],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "activateExternalCustomerByToken"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "input"
            }
          }
        }],
        directives: [],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "success"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "customer"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "externalId"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "firstName"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "encrypted"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "masked"
                    },
                    arguments: [],
                    directives: []
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "email"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "encrypted"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "masked"
                    },
                    arguments: [],
                    directives: []
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "lastName"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "encrypted"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "masked"
                    },
                    arguments: [],
                    directives: []
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "address"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "encrypted"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "masked"
                    },
                    arguments: [],
                    directives: []
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "postalCode"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "encrypted"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "masked"
                    },
                    arguments: [],
                    directives: []
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "mobilePhoneNumber"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "encrypted"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "masked"
                    },
                    arguments: [],
                    directives: []
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "city"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "encrypted"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "masked"
                    },
                    arguments: [],
                    directives: []
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "co"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "encrypted"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "masked"
                    },
                    arguments: [],
                    directives: []
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }],
  loc: {
    start: 0,
    end: 649,
    source: {
      body: "mutation ActivateExternalToken($input: ActivateExternalCustomerByTokenInput!) {\n  activateExternalCustomerByToken(input: $input) {\n    success\n    customer {\n      externalId\n      firstName {\n        encrypted\n        masked\n      }\n      email {\n        encrypted\n        masked\n      }\n      lastName {\n        encrypted\n        masked\n      }\n      address {\n        encrypted\n        masked\n      }\n      postalCode {\n        encrypted\n        masked\n      }\n      mobilePhoneNumber {\n        encrypted\n        masked\n      }\n      city {\n        encrypted\n        masked\n      }\n      co {\n        encrypted\n        masked\n      }\n    }\n  }\n}\n",
      name: "GraphQL request",
      locationOffset: {
        line: 1,
        column: 1
      }
    }
  }
},
    N = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "ActivateExternalCustomerById"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "input"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "ActivateExternalCustomerByIdInput"
          }
        }
      },
      directives: []
    }],
    directives: [],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "activateExternalCustomerById"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "input"
            }
          }
        }],
        directives: [],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "success"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "token"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "value"
                },
                arguments: [],
                directives: []
              }]
            }
          }]
        }
      }]
    }
  }],
  loc: {
    start: 0,
    end: 180,
    source: {
      body: "mutation ActivateExternalCustomerById($input: ActivateExternalCustomerByIdInput!) {\n  activateExternalCustomerById(input: $input) {\n    success\n    token {\n      value\n    }\n  }\n}\n",
      name: "GraphQL request",
      locationOffset: {
        line: 1,
        column: 1
      }
    }
  }
},
    f = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "ExternalLookupQuery"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "key"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      },
      directives: []
    }],
    directives: [],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "externalCustomerLookup"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "key"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "key"
            }
          }
        }],
        directives: [],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "status"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "customer"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "externalId"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "firstName"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "encrypted"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "masked"
                    },
                    arguments: [],
                    directives: []
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "email"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "encrypted"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "masked"
                    },
                    arguments: [],
                    directives: []
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "lastName"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "encrypted"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "masked"
                    },
                    arguments: [],
                    directives: []
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "address"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "encrypted"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "masked"
                    },
                    arguments: [],
                    directives: []
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "postalCode"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "encrypted"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "masked"
                    },
                    arguments: [],
                    directives: []
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "mobilePhoneNumber"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "encrypted"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "masked"
                    },
                    arguments: [],
                    directives: []
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "city"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "encrypted"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "masked"
                    },
                    arguments: [],
                    directives: []
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "co"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "encrypted"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "masked"
                    },
                    arguments: [],
                    directives: []
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "country"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "encrypted"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "masked"
                    },
                    arguments: [],
                    directives: []
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "countryCode"
                },
                arguments: [],
                directives: []
              }]
            }
          }]
        }
      }]
    }
  }],
  loc: {
    start: 0,
    end: 673,
    source: {
      body: "query ExternalLookupQuery($key: String!) {\n  externalCustomerLookup(key: $key) {\n    status\n    customer {\n      externalId\n      firstName {\n        encrypted\n        masked\n      }\n      email {\n        encrypted\n        masked\n      }\n      lastName {\n        encrypted\n        masked\n      }\n      address {\n        encrypted\n        masked\n      }\n      postalCode {\n        encrypted\n        masked\n      }\n      mobilePhoneNumber {\n        encrypted\n        masked\n      }\n      city {\n        encrypted\n        masked\n      }\n      co {\n        encrypted\n        masked\n      }\n      country {\n        encrypted\n        masked\n      }\n      countryCode\n    }\n  }\n}\n",
      name: "GraphQL request",
      locationOffset: {
        line: 1,
        column: 1
      }
    }
  }
},
    S = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "LoginExternalCustomer"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "input"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "LoginExternalCustomerInput"
          }
        }
      },
      directives: []
    }],
    directives: [],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "loginExternalCustomer"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "input"
            }
          }
        }],
        directives: [],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "token"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "value"
                },
                arguments: [],
                directives: []
              }]
            }
          }]
        }
      }]
    }
  }],
  loc: {
    start: 0,
    end: 147,
    source: {
      body: "mutation LoginExternalCustomer($input: LoginExternalCustomerInput!) {\n  loginExternalCustomer(input: $input) {\n    token {\n      value\n    }\n  }\n}\n",
      name: "GraphQL request",
      locationOffset: {
        line: 1,
        column: 1
      }
    }
  }
},
    x = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "PersonLookup"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "key"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      },
      directives: []
    }],
    directives: [],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "personLookup"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "key"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "key"
            }
          }
        }],
        directives: [],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "firstName"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "encrypted"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "masked"
                },
                arguments: [],
                directives: []
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "lastName"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "encrypted"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "masked"
                },
                arguments: [],
                directives: []
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "address"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "encrypted"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "masked"
                },
                arguments: [],
                directives: []
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "postalCode"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "encrypted"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "masked"
                },
                arguments: [],
                directives: []
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "mobilePhoneNumber"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "encrypted"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "masked"
                },
                arguments: [],
                directives: []
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "city"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "encrypted"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "masked"
                },
                arguments: [],
                directives: []
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "co"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "encrypted"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "masked"
                },
                arguments: [],
                directives: []
              }]
            }
          }]
        }
      }]
    }
  }],
  loc: {
    start: 0,
    end: 421,
    source: {
      body: "query PersonLookup($key: String!) {\n  personLookup(key: $key) {\n    firstName {\n      encrypted\n      masked\n    }\n    lastName {\n      encrypted\n      masked\n    }\n    address {\n      encrypted\n      masked\n    }\n    postalCode {\n      encrypted\n      masked\n    }\n    mobilePhoneNumber {\n      encrypted\n      masked\n    }\n    city {\n      encrypted\n      masked\n    }\n    co {\n      encrypted\n      masked\n    }\n  }\n}\n",
      name: "GraphQL request",
      locationOffset: {
        line: 1,
        column: 1
      }
    }
  }
};

function E(e) {
  var i = s.useHistory(),
      t = o.useApolloClient(),
      u = s.useLocation().search,
      l = r(),
      m = l.loggedIn,
      k = l.logIn,
      v = d.parse(u, {
    ignoreQueryPrefix: !0
  }).eclub,
      p = void 0 === v ? "" : v,
      g = a.useMachine(_(e), {
    context: {
      externalCustomerToken: encodeURIComponent(p)
    },
    services: {
      tryLoginWithExternalToken: function tryLoginWithExternalToken(e) {
        return function (e, n) {
          var i = n.callback;
          return n.client.mutate({
            mutation: S,
            variables: {
              input: {
                externalCustomerToken: e.externalCustomerToken
              }
            }
          }).then(function (e) {
            var n,
                t,
                a,
                o = e.data;
            return null != o && null !== (n = o.loginExternalCustomer.token) && void 0 !== n && n.value ? Promise.resolve(i(null == o || null === (t = o.loginExternalCustomer) || void 0 === t || null === (a = t.token) || void 0 === a ? void 0 : a.value)) : Promise.reject();
          }, function (e) {
            return Promise.reject(e);
          });
        }(e, {
          client: t,
          callback: k
        });
      },
      tryActivateByExternalToken: function tryActivateByExternalToken(e) {
        return function (e, n) {
          return n.client.mutate({
            mutation: y,
            variables: {
              input: {
                externalCustomerToken: e.externalCustomerToken
              }
            },
            errorPolicy: "all"
          }).then(function (e) {
            var n = e.data,
                i = e.errors;
            return i ? Promise.reject(c({
              error: c({}, i)
            }, n)) : Promise.resolve(n);
          });
        }(e, {
          client: t
        });
      }
    },
    guards: {
      shouldInitialize: function shouldInitialize() {
        return p.length > 0 && !m;
      }
    }
  })[0],
      N = n.useMemo(function () {
    return {
      isAdditionalDataRequired: g.matches("action_required.activation_failed.additional_data"),
      isNonExistingCustomer: g.matches("action_required.activation_failed.non_existing"),
      isActivationRequired: g.matches("action_required.activation_failed.already_activated"),
      isActionPending: g.matches("checking_action_required") || g.matches("action_required.try_activate") || g.matches("action_required.activation_failed.status_response")
    };
  }, [g.value]),
      f = N.isAdditionalDataRequired,
      x = N.isNonExistingCustomer,
      E = g.context.providerOptions.redirectOnLookupFailure;
  return n.useEffect(function () {
    if (E && (f || x)) {
      var n = g.context.customer;
      i.push(e.signupPath || "/signup", c({}, n && {
        customer: n
      }, {
        status: c({}, N)
      }));
    }
  }, [f, x]), c({}, N);
}

var F,
    L = n.createContext({}),
    C = {
  activateOnLookup: !1,
  signInOnActivation: !1,
  personLookupConfigured: !1,
  manualPersonLookup: !1
},
    h = t.send(function (e, n) {
  return {
    type: n.data.externalCustomerLookup.status,
    data: n.data.externalCustomerLookup
  };
}),
    O = t.assign({
  customer: function customer(e, n) {
    var i, t;
    return c({}, e.customer, ((t = {})[null !== (i = n.data.inputName) && void 0 !== i ? i : "emailAddress"] = {
      masked: n.data.lookupKey,
      encrypted: n.data.lookupKey
    }, t));
  }
}),
    A = t.assign({
  lookupKey: function lookupKey(e, n) {
    var i, t;
    return null !== (i = null == n || null === (t = n.data) || void 0 === t ? void 0 : t.lookupKey) && void 0 !== i ? i : e.lookupKey;
  }
}),
    T = t.assign({
  customer: function customer(e, n) {
    var i, t;
    return null !== (i = n.data) && void 0 !== i && null !== (t = i.externalCustomerLookup) && void 0 !== t && t.customer ? c({}, e.customer, {}, n.data.externalCustomerLookup.customer, {
      emailAddress: n.data.externalCustomerLookup.customer.email,
      streetName: n.data.externalCustomerLookup.customer.address,
      mobilePhone: n.data.externalCustomerLookup.customer.mobilePhoneNumber
    }) : c({}, e.customer);
  }
}),
    b = t.assign({
  customer: function customer(e, n) {
    var i;
    return null != n && null !== (i = n.data) && void 0 !== i && i.personLookup ? c({}, e.customer, {}, n.data.personLookup, {
      streetName: n.data.personLookup.address
    }) : c({}, e.customer);
  }
}),
    I = t.assign({
  customer: function customer(e, n) {
    return c({}, e.customer, {
      token: n.data.activateExternalCustomerById.token.value
    });
  }
}),
    D = t.assign({
  activationError: function activationError() {
    return "";
  }
}),
    q = t.Machine({
  id: "LookupMachine",
  initial: "idle",
  context: {
    activationError: null,
    lookupKey: "",
    customer: void 0,
    lookupOptions: {}
  },
  states: {
    idle: {
      id: "idle",
      on: {
        DO_LOOKUP: "lookup"
      }
    },
    lookup: {
      id: "lookup",
      entry: ["storeLookupKey", "storeEmail"],
      initial: "lookup_loading",
      states: {
        lookup_loading: {
          invoke: {
            id: "fetchLookupStatus",
            src: "externalLookup",
            onDone: {
              target: "lookup_success",
              actions: ["sendLookupSuccessEvent"]
            },
            onError: "lookup_failed"
          }
        },
        lookup_failed: {
          on: {
            DO_LOOKUP: "#lookup"
          }
        },
        lookup_success: {
          initial: "status_response",
          entry: "storeCustomer",
          states: {
            status_response: {
              on: (F = {}, F.ACTIVATION_REQUIRED = "#activation", F.PREEXISTING_CUSTOMER = "#preexisting", F.ADDITIONAL_USER_DATA_REQUIRED = "#additional_data", F.NON_EXISTING_CUSTOMER = "non_existing", F.COUNTRY_NOT_VALID = "#country_not_valid", F)
            },
            activation: {
              id: "activation",
              initial: "activation_required",
              states: {
                activation_required: {
                  always: {
                    target: "activation_loading",
                    cond: function cond(e) {
                      return e.lookupOptions.activateOnLookup;
                    }
                  },
                  on: {
                    ACTIVATE_CUSTOMER: "activation_loading"
                  }
                },
                activation_loading: {
                  invoke: {
                    id: "activate-customer-by-externalid",
                    src: "activateExternalId",
                    onDone: {
                      actions: "storeToken",
                      target: "activation_success"
                    },
                    onError: "activation_failed"
                  }
                },
                activation_success: {
                  id: "activation_success",
                  initial: "try_login",
                  states: {
                    try_login: {
                      always: [{
                        target: "login",
                        cond: function cond(e) {
                          return e.lookupOptions.signInOnActivation;
                        }
                      }, {
                        target: "customer_created"
                      }]
                    },
                    login: {
                      invoke: {
                        id: "login",
                        src: "login",
                        onDone: "customer_created",
                        onError: "login_failed"
                      }
                    },
                    login_failed: {
                      type: "final"
                    },
                    customer_created: {
                      type: "final"
                    }
                  }
                },
                activation_failed: {
                  entry: "setActivationError",
                  on: {
                    DO_LOOKUP: "#lookup"
                  }
                }
              }
            },
            preexisting: {
              id: "preexisting",
              type: "final"
            },
            additional_data: {
              id: "additional_data",
              type: "final"
            },
            non_existing: {
              id: "non_existing",
              initial: "check_person_lookup_configured",
              states: {
                check_person_lookup_configured: {
                  always: [{
                    target: "person_lookup_configured",
                    cond: function cond(e) {
                      return e.lookupOptions.personLookupConfigured;
                    }
                  }, {
                    target: "non_existing_customer",
                    cond: function cond(e) {
                      return !e.lookupOptions.personLookupConfigured;
                    }
                  }]
                },
                non_existing_customer: {
                  type: "final"
                },
                person_lookup_configured: {
                  initial: "person_lookup_idle",
                  states: {
                    person_lookup_idle: {
                      always: [{
                        target: "person_lookup_loading",
                        cond: function cond(e) {
                          return !e.lookupOptions.manualPersonLookup;
                        }
                      }],
                      on: {
                        DO_PERSON_LOOKUP: "person_lookup_loading"
                      }
                    },
                    person_lookup_loading: {
                      entry: "storeLookupKey",
                      invoke: {
                        id: "fetch_person_lookupdata",
                        src: "personLookup",
                        onDone: {
                          target: "person_lookup_success"
                        },
                        onError: "person_lookup_failed"
                      },
                      exit: "storeLookupData"
                    },
                    person_lookup_success: {
                      id: "person_lookup_success",
                      type: "final"
                    },
                    person_lookup_failed: {
                      id: "person_lookup_failed",
                      type: "final"
                    }
                  }
                }
              }
            },
            country_not_valid: {
              id: "country_not_valid",
              on: {
                DO_LOOKUP: "#lookup"
              }
            }
          }
        }
      }
    }
  }
}, {
  actions: {
    sendLookupSuccessEvent: h,
    setActivationError: D,
    storeEmail: O,
    storeLookupKey: A,
    storeCustomer: T,
    storeToken: I,
    storeLookupData: b
  }
});
exports.LookupMachine = q, exports.VoyadoContext = L, exports.VoyadoProvider = function (e) {
  var n = E(c({}, e.providerOptions));
  return i.createElement(L.Provider, Object.assign({
    value: n
  }, e));
}, exports.createSoftLoginMachine = _, exports.defaultLookupOptions = C, exports.useLoginStatus = function (e) {
  var n = e.loginMutation,
      i = l.useCookies(["authToken"]),
      t = i[0].authToken,
      a = i[1],
      r = i[2],
      s = o.useMutation(n, {
    onCompleted: function onCompleted(e) {
      r("authToken"), a("authToken", e.login.token.value, {
        path: "/"
      });
    }
  }),
      d = s[0],
      m = s[1],
      k = m.error,
      v = m.loading;
  if (!t) return {
    isSoftLoggedIn: !1
  };
  var p = u(t);
  return {
    isSoftLoggedIn: 2 === Number(null == p ? void 0 : p.role),
    authorize: function authorize(e) {
      return d({
        variables: c({}, e)
      });
    },
    error: k,
    loading: v
  };
}, exports.useSoftLogin = E, exports.useSoftLoginStatus = function () {
  return n.useContext(L) || Error("useSemiLoginStatus cannot be used outside VoyadoProvider");
}, exports.useVoyadoLookup = function (e) {
  void 0 === e && (e = {});
  var i = o.useApolloClient(),
      t = r().logIn,
      s = a.useMachine(q, {
    services: {
      externalLookup: function externalLookup(e, n) {
        return function (e, n) {
          return n.client.query({
            query: f,
            variables: {
              key: e.data.lookupKey
            }
          }).then(function (e) {
            return e.data;
          });
        }(n, {
          client: i
        });
      },
      activateExternalId: function activateExternalId(e) {
        return function (e, n) {
          return n.client.mutate({
            mutation: N,
            variables: {
              input: {
                externalCustomerId: e.customer.externalId
              }
            }
          }).then(function (e) {
            return e.data;
          });
        }(e, {
          client: i
        });
      },
      personLookup: function personLookup(e) {
        return function (e, n) {
          return n.client.query({
            query: x,
            variables: {
              key: e.lookupKey
            }
          }).then(function (e) {
            return e.data;
          });
        }(e, {
          client: i
        });
      },
      login: function login(e) {
        return new Promise(function (n, i) {
          var a;
          null != e && null !== (a = e.customer) && void 0 !== a && a.token ? n(t(e.customer.token)) : i();
        });
      }
    },
    context: {
      customer: void 0,
      lookupOptions: c({}, C, {}, e.lookupOptions)
    }
  }),
      d = s[0],
      u = s[1];
  return c({
    lookup: function lookup(e, n) {
      u({
        type: "DO_LOOKUP",
        data: {
          lookupKey: e,
          inputName: n
        }
      });
    },
    activate: function activate() {
      u({
        type: "ACTIVATE_CUSTOMER"
      });
    },
    personLookup: function personLookup(e) {
      u({
        type: "DO_PERSON_LOOKUP",
        data: {
          lookupKey: e
        }
      });
    }
  }, n.useMemo(function () {
    return {
      isInActivation: d.matches("lookup.lookup_success.activation"),
      isActivationRequired: d.matches("lookup.lookup_success.activation.activation_required"),
      isActivationPending: d.matches("lookup.lookup_success.activation.activation_loading"),
      isActivationSuccess: d.matches("lookup.lookup_success.activation.activation_success.customer_created"),
      isActivationFailed: d.matches("lookup.lookup_success.activation.activation_failed"),
      isPreExistingCustomer: d.matches("lookup.lookup_success.preexisting"),
      isAdditionalDataRequired: d.matches("lookup.lookup_success.additional_data"),
      isNonExistingCustomer: d.matches("lookup.lookup_success.non_existing.non_existing_customer"),
      isCountryNotValid: d.matches("lookup.lookup_success.country_not_valid"),
      isLookupPending: d.matches("lookup.lookup_loading"),
      isPersonLookupIdle: d.matches("lookup.lookup_success.non_existing.person_lookup_configured.person_lookup_idle"),
      isPersonLookupPending: d.matches("lookup.lookup_success.non_existing.person_lookup_configured.person_lookup_loading") && !d.context.lookupOptions.manualPersonLookup,
      isPersonLookupFailed: d.matches("lookup.lookup_success.non_existing.person_lookup_configured.person_lookup_failed"),
      isPersonLookupSuccess: d.matches("lookup.lookup_success.non_existing.person_lookup_configured.person_lookup_success"),
      error: {
        lookupError: d.matches("lookup.lookup_failed"),
        activationError: d.matches("lookup.lookup_success.activation.activation_failed"),
        errorMessage: d.context.activationError
      }
    };
  }, [d.value]), {
    customer: d.context.customer
  });
}; //# sourceMappingURL=flight-voyado.cjs.production.min.js.map